export default __webpack_public_path__ + "static/media/logo-htc-vive.dcfca7d5.svg";